<template>
  <div>
    <breadcrumb-bar
      :crumbs="[{name:'Groups'},{name:'Messaging', link:'Messaging Home'},{name:'Message History', link:'Message History'}]"></breadcrumb-bar>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="portlet light">
              <div class="portlet-title">
                <div class="caption caption-md">
                  <span class="caption-subject bold uppercase">Message History</span>
                </div>
                <div class="actions" v-if="messages.length > 0 || Object.keys(serverParams.columnFilters).length !== 0 && serverParams.columnFilters.constructor === Object">
                  <a class="btn btn-circle btn-icon-only btn-default"
                     style="width:35px; height:35px; padding: 6px;"
                     @click.prevent="exportHistory()">
                    <img src="/static/global/img/csv-ico.svg" style="width:20px;">
                  </a>
                </div>
              </div>
              <div class="portlet-body">
                <p>
                  {{ stats.sent }} of {{ stats.all }} messages sent successfully.
                </p>
                <div class="vue-good-table" v-if="messages.length > 0 || Object.keys(serverParams.columnFilters).length !== 0 && serverParams.columnFilters.constructor === Object">
                  <vue-good-table
                    :columns="columns"
                    :rows="messages"
                    :pagination-options="{
                      enabled: true,
                        perPageDropdown: [10, 20, 50, 100, 200, 500],
                        dropdownAllowAll: true,
                        perPage: this.serverParams.perPage
                      }"
                    mode="remote"
                    :totalRows="totalRecords"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"

                  >
                    <template slot="table-column" slot-scope="props">
                      {{ props.column.label }}
                    </template>

                    <template slot="table-row" slot-scope="props">
                      <template v-if="props.column.field==='after'">
                        <a href="#" class="btn green btn-sm">View</a>
                      </template>
                      <template v-else>{{props.formattedRow[props.column.field]}}</template>
                    </template>

                  </vue-good-table>
                </div>
                <div class="not-found-results" v-else>
                  <h4>No message history found.</h4>
                </div>
                <router-link tag="button" class="btn green pull-left" :to="{ name: 'Message History' }">
                  Back
                </router-link>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import Spinner from '@/components/Spinner';
import {mapActions, mapGetters} from 'vuex';
import participantDisplayName from '@/mixins/participantDisplayName';

export default {
  mixins: [
    participantDisplayName
  ],
  data() {
    return {
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10
      }
    }
  },
  components: {
    'breadcrumb-bar': Breadcrumbs,
    'vue-spinner': Spinner
  },
  created() {
    this.getMessagesList();
  },
  computed: {
    ...mapGetters({
      messages: 'getMassMessagesDetails',
      totalRecords: 'getMassMessagesDetailsCount',
      stats: 'getMassMessagesStats'
    }),
    columns () {
      return [
        {
          label: `${this.participantSingularName} Name`,
          field: 'participant',
          filterOptions: {enabled: true}
        },
        {
          label: 'System ID',
          field: 'system_id',
          filterOptions: {enabled: true}
        },
        {
          label: 'Organization ID',
          field: 'organization_id',
          filterOptions: {enabled: true}
        },
        {
          label: 'Status',
          field: 'status',
          filterOptions: {enabled: true}
        }
      ]
    },
  },
  methods: {
    ...mapActions({
      getMassMessagesDetailsAction: 'GET_MASS_MESSAGES_DETAILS_ACTION',
      exportHistory: 'MASS_MESSAGES_EXPORT_HISTORY'
    }),
    getMessagesList() {
      this.getMassMessagesDetailsAction({
        columns_filter: this.serverParams.columnFilters,
        limit: this.serverParams.perPage,
        current_page: this.serverParams.page,
        sort_by: this.serverParams.sort.field,
        sort_order: this.serverParams.sort.type,
      });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.getMessagesList();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage, page: 1});
      this.getMessagesList();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        },
      });
      this.getMessagesList();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.getMessagesList();
    }


  }
}
</script>

<style scoped>
.vue-good-table {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// HistoryDetails.vue?5602ad59